import { IIconProps } from '~/types';
const InfoIcon = ({ size = 18, fill = '#B0AFB6', ...props }: IIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.752 17.333C4.9 17.333.967 13.603.967 9S4.9.667 9.752.667 18.538 4.397 18.538 9s-3.934 8.333-8.786 8.333m0-1.666c3.882 0 7.029-2.985 7.029-6.667s-3.147-6.667-7.029-6.667C5.871 2.333 2.724 5.318 2.724 9s3.147 6.667 7.028 6.667M8.874 4.833h1.757V6.5H8.874zm0 3.334h1.757v5H8.874z"
      fill={fill}
    />
  </svg>
);
export default InfoIcon;
